import { IsDateString, IsOptional, IsString } from 'class-validator';

export class RefreshUserRequestDto {
  @IsString()
  userId!: string;

  @IsOptional()
  @IsString()
  providerName?: string;

  @IsOptional()
  @IsDateString()
  since?: string;

  @IsOptional()
  @IsDateString()
  until?: string;
}
